export const toLocaleDateString = (
  date: Date | string,
  locales: Intl.LocalesArgument = 'uk'
) => {
  if (date instanceof Date) {
    return date.toLocaleDateString(locales);
  }
  return new Date(date).toLocaleDateString(locales);
};
